export type Roles = 'guest' | 'admin' | 'clerk';

export const userRoles = [
  { name: 'Guest', value: 'guest', color: 'info' },
  { name: 'Admin', value: 'admin', color: 'primary' },
  { name: 'Clerk', value: 'clerk', color: 'warning' },
];

export const getUserRole = (value: Roles) => {
  return userRoles.find((role) => role.value === value);
};
